import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { inject } from 'mobx-react'
import { Avatar } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const MUNICIPALITY_LOGO = gql`
	query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
	}
`

const BarangayLogo = (props) => {
	const { 
		AuthStore, client, user_uid, ...rest 
	} = props
	const { barangay_uid } = AuthStore

	return (
		
		<Query 
			query={MUNICIPALITY_LOGO}
			variables={{ barangay_uid, code: 'MUNICIPAL_LOGO' }}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const logo = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				//console.log('userAvatar', userAvatar)
				const logoUrl = _.has(logo, 'value') ?
					`${process.env.REACT_APP_BACKEND_API}${logo.value}` 
					: 'https://thumbs.dreamstime.com/b/no-image-vector-symbol-missing-available-icon-no-gallery-moment-no-image-vector-symbol-missing-available-icon-no-gallery-169136238.jpg'
				return (
					<img { ...rest } src={logoUrl} alt='municipal-logo' />
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo,
	inject('AuthStore')
)

export default composed(BarangayLogo)